import { createApp } from 'vue';
import App from './App.vue';
// 路由
import router from '@/router';
// 导入UI框架
import Vant,{Icon} from 'vant';
import 'vant/lib/index.css';
// 定制主题
import { ConfigProvider } from 'vant';



// 动态设置title
router.beforeEach((to)=>{
  if(to.meta.title){
    document.title = to.meta.title;
  }
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || undefined;
  if(to.path !== "/login" && !currentUser){
    router.push("/login")
  }
})

createApp(App).use(router).use(Vant).use(Icon).use(ConfigProvider).mount('#app');
